<template>
	<div style="width: 100%;">
		<div style="position: relative;">
			<el-form :model="data" :rules="rules" ref="widgetForm">
				<div v-if="data.type==0" data-is-check="false">
					<el-form-item label="上传图片：" prop="imageUrl0">
						<el-upload :class="disabled?'disabled avatar-uploader':'avatar-uploader'" :disabled="disabled" :action="uploadUrl" :data="uploadData" name="attachFile" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<img v-if="data.imageUrl0" :src="data.imageUrl0" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</div>
				<div v-if="data.type==1" class="">
					<el-form-item label="上传图片：" prop="imageUrl0">
						<div style="display: flex;">
							<el-upload :class="disabled?'disabled '+'avatar-uploader avatar-uploader1':''+'avatar-uploader avatar-uploader1'" :data="uploadData" :disabled="disabled" style="border-right: none;" :action="uploadUrl" name="attachFile" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
								<img v-if="data.imageUrl0" :src="data.imageUrl0" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
							<el-upload :style="" :class="disabled?'disabled '+'avatar-uploader avatar-uploader1':''+'avatar-uploader avatar-uploader1'" :data="uploadData" :disabled="disabled" :action="uploadUrl" name="attachFile" :show-file-list="false" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
								<img v-if="data.imageUrl1" :src="data.imageUrl1" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</div>
					</el-form-item>

				</div>
				<div v-if="data.type==2">
					<el-form-item label="上传背景图片：" prop="imageUrl0">
						<el-upload :class="disabled?'disabled avatar-uploader':'avatar-uploader'" :disabled="disabled" :action="uploadUrl" name="attachFile" :data="uploadData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<img v-if="data.imageUrl0" :src="data.imageUrl0" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="视频id：" prop="link">
						<el-input v-model="data.link" :disabled="disabled"></el-input>
					</el-form-item>
				</div>
				<div v-if="data.type==3">
					<el-form-item label="上传背景图片：" prop="imageUrl0">
						<el-upload :class="disabled?'disabled avatar-uploader':'avatar-uploader'" :disabled="disabled" :action="uploadUrl" name="attachFile" :data="uploadData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<img v-if="data.imageUrl0" :src="data.imageUrl0" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="上传按钮背景图片：" prop="imageUrl1">

						<el-upload :class="disabled?'disabled '+'avatar-uploader avatar-uploader3':''+'avatar-uploader avatar-uploader3'" :disabled="disabled" :data="uploadData" :action="uploadUrl" name="attachFile" :show-file-list="false" :on-success="handleAvatarSuccess1">
							<img v-if="data.imageUrl1" :src="data.imageUrl1" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="表单距离顶部位置：" prop="position">
						<el-input v-model="data.position" type="number" class="middle-input" :disabled="disabled"></el-input>%
					</el-form-item>
				</div>
				<div class="sub-title">控件描述：</div>
				<el-input type="textarea" v-model="data.desc" :disabled="disabled" placeholder="请输入描述(30字以内)"></el-input>

				<div :class="disabled?'new-add disabled':'new-add'" @click="addHot()" v-if="data.type==0||data.type==1">新增热区</div>
				<div v-for="(item,index) in hotData">
					<div class="sub-title"><i style="color: #f56c6c;margin-right: 4px;">*</i>{{'热区链接'+activeIndex+'-'+(index*1)+'：'}}</div>
					<el-input class="middle-input" v-model="item.link" :disabled="disabled"></el-input><span style="color: red;font-size: 12px; cursor: pointer;" @click="deleteHot(index)">删除</span>
				</div>
				<div class="btn">
					<span class="lock" @click="undraggable" v-if="userType==0">{{disabled?"解锁控件":"锁定控件"}}</span>
					<span :class="disabled?'delete disabled':'delete'" @click="deleteWidget" v-if="userType==0">删除控件</span>
				</div>
			</el-form>
		</div>

	</div>
</template>
<script>
	import '../assets/iconfont.css';
	import VueDraggableResizable from '../components/vue-draggable-resizable.vue'
	// 引入拖拽组件
	export default {
		name: 'PostElement',
		props: {
			data: [Object],
			hotData: [Array],
			disabled: [Boolean],
			width: [Number],
			uploadUrl: [String],
			changeImgHeight: [Function],
			activeIndex: [Number],
			userType: [Number]
		},
		components: {
			VueDraggableResizable
		},
		data() {
			return {
				uploadData: {
					type: 'images'
				},
				rules: {
					link: [{
							required: true,
							message: '请将信息填写完整',
							trigger: 'blur'

						},

					],
					desc: [{
						min: 0,
						max: 30,
						message: '控件描述30字以内',
						trigger: 'blur'
					}],
					imageUrl0: [{
						required: true,
						message: '请上传图片',
						trigger: 'change',
					}],
					imageUrl1: [{
						required: true,
						message: '请上传图片',
						trigger: 'change',
					}],

				}

			}
		},
		methods: {
			//增加热区
			addHot() {
				if(!this.disabled) {
					this.$emit('addHot')
				}

			},
			changeValidate(resolve) {
				let isValid = true;
				if(this.hotData && this.hotData.length > 0) {
					this.hotData.map((item, index) => {
						if(!item.link) {
							isValid = false
						}
					})
					if(!isValid) {
						this.$message({
							message: '请将该控件的热区链接填写完整，否则将无法选择其他控件',
							type: 'warning'
						});

						return
					}

				}
				this.$refs.widgetForm.validate((valid) => {

					resolve(valid)
				})

			},
			uploadImg(data, type) {
				if(data.result) {
					this.$emit('uploadImg', data.value, type);
				} else {
					this.$message({
						message: data.value,
						type: 'warning'
					});

				}
			},
			handleAvatarSuccess(data, file) {
				this.uploadImg(data, 0, this.imgHeight)
			},
			handleAvatarSuccess1(data, file) {
				this.uploadImg(data, 1, this.imgHeight)
			},

			beforeAvatarUpload(file) {
				let that = this;
				
				//				const isJPG = file.type === 'image/jpeg';
				const isLt1M = file.size / 1024 / 1024 < 1;
				
				if(!isLt1M) {
					this.$message({
						message: '上传图片大小不能超过 1MB!',
						type: 'warning'
					});
					return
				}
				const isWidth = new Promise(function(resolve, reject) {
					let _URL = window.URL || window.webkitURL;
					let img = new Image();
					img.onload = function() {
						let valid = img.width == that.width;
						var pre = (img.width / img.height).toFixed(2)
						that.changeImgHeight(pre);
						valid ? resolve() : reject();
					}
					img.src = _URL.createObjectURL(file);
				}).then(() => {
					return file;
				}, () => {
					this.$message({
						message: '上传的图片宽度不等于' + that.width,
						type: 'warning'
					});
					//					return Promise.reject();
				});

				return isWidth
			},
			deleteWidget() {
				this.$emit('deleteWidget')
			},
			undraggable() {
				this.$emit('undraggable')
			},
			deleteHot(index) {
				this.$emit('deleteHot', index)
			}
		},

		watch: {}
	}
</script>

<style scoped lang="less">
	.avatar-uploader {
		position: relative;
		width: 254px;
		height: 92px;
		border: 1px solid #D6D6D6;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
		color: #D8D8D8;
		img {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
		&.avatar-uploader1 {
			width: 50%;
		}
		&.avatar-uploader3 {
			width: 60px;
			height: 38px;
			font-size: 16px;
		}
	}
	
	.wrapper .detail .sub-title {
		color: #666;
		font-size: 12px;
		margin-top: 18px;
		line-height: 30px;
	}
	
	.new-add {
		background: #F65959;
		border-radius: 3px;
		color: #FFFFFF;
		cursor: pointer;
		width: 80px;
		height: 27px;
		font-size: 12px;
		text-align: center;
		line-height: 27px;
		margin-top: 20px;
	}
	
	.btn {
		display: flex;
		justify-content: space-around;
		margin-top: 20px;
		margin-bottom: 100px;
		span {
			width: 80px;
			height: 27px;
			font-size: 12px;
			text-align: center;
			line-height: 27px;
			cursor: pointer;
		}
		.lock {
			margin-right: 10px;
			border: 1px solid #F65959;
			border-radius: 3px;
			color: #F65959;
		}
		.delete {
			background: #F65959;
			border-radius: 3px;
			color: #FFFFFF;
			cursor: pointer;
		}
	}
	
	/deep/ textarea {
		font-family: Arial!important;
	}
	
	.disabled {
		background: #f5f7fa;
	}
	
	/deep/ .middle-input input,
	/deep/ .middle-input {
		width: 200px;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Widget.vue